import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/JwtContext';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/global/ErrorFallback";
import { SnackbarProvider } from 'notistack';
import './locales/i18n';
import { PermissionsProvider } from './auth/PermissionsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <PermissionsProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => window.location.replace("/")}>
          <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
            <App />
          </SnackbarProvider>
        </ErrorBoundary>
      </PermissionsProvider>
    </AuthProvider>
  </React.StrictMode>
);
